/**
 * @generated SignedSource<<b95bbef989639fb52285177bea86687d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type NoteStreamType = "goalset" | "meeting" | "oneonone" | "personal";
export type StatusChoices = "busy" | "cancelled" | "confirmed" | "free" | "needsAction" | "oof" | "tentative" | "unknown" | "workingElsewhere";
import { FragmentRefs } from "relay-runtime";
export type NoteHeaderNoteDateOrTimer_note$data = {
  readonly createdAt: string | null;
  readonly event: {
    readonly status: StatusChoices;
  } | null;
  readonly eventEnd: string | null;
  readonly eventGuid: string | null;
  readonly eventStart: string | null;
  readonly id: string;
  readonly noteType: NoteStreamType;
  readonly stream: {
    readonly isExternal: boolean;
  };
  readonly viewerCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"NoteTimeSelectorModal_note">;
  readonly " $fragmentType": "NoteHeaderNoteDateOrTimer_note";
};
export type NoteHeaderNoteDateOrTimer_note$key = {
  readonly " $data"?: NoteHeaderNoteDateOrTimer_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"NoteHeaderNoteDateOrTimer_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NoteHeaderNoteDateOrTimer_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventEnd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "noteType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isExternal",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventGuid",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NoteTimeSelectorModal_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "cfbc24af3e2e6b4a33aa6826a7137e2c";

export default node;
